/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import {
    object, func, shape, string, bool, arrayOf,
} from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import AddressVerificationSearch from '../AddressVerificationSearch/AddressVerificationSearch';
import AddressVerificationSearchV2 from '../AddressVerificationSearchV2/AddressVerificationSearchV2';
import GoogleAddressSearch from '../GoogleAddressSearch/GoogleAddressSearch';
import QasAddressVerificationModal from '../QasAddressVerification/QasAddressVerificationModal';
import InlineErrorMessage from '../ErrorMessage/InlineErrorMessage';
import TextFieldWrapper from '../TextFieldWrapper/TextFieldWrapper';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import withValidation from '../TextFieldWrapper/ValidationHOC';
import DisplayLinkField from '../DisplayLinkField/DisplayLinkField';

import {
    countriesProps,
    getFlagError,
    getFormattedRecipientData,
    getFieldsToValidateRecipient,
    getInputProperties,
    getNonFieldErrors,
    getListCountries,
    getListLocationTypes, getListStates,
    inputStates,
    useGoogleAddressSearch, useQasAddressSearch, getOnlyInputFieldErrors,
    getListRelationShipDropdown,
    recipientBuilder,
    triggerStateCityData,
    isUsaOrCanada,
} from '../Helpers/Input-Helper';

import {
    getRecipientFormError, getFlags, getHasQasFailed,
    getUserSubmittedProductFilterZipcode, getLocationType,
} from '../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import {
    getUserType,
} from '../../../../../../../state/ducks/Checkout/ducks/Global/Global-Selectors';
import { clearOrderItemErrors, setOrderItemError } from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/Error/Error-Actions';

import { resetQasAddressState } from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/AddressSearchQAS/AddressSearchQAS-Actions';
import { getOrderItemErrors } from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/Error/Error-Selector';
import { getBrandProductFamily } from '../Helpers/Helper';
import { useModalContext } from '../ModalContext/modal-context';
import { propertiesTypeByProduct } from '../Helpers/Sku-helper';
import { enterpriseQASSaveRecipient, enterpriseSaveAddressBook } from '../../../../../../../state/ducks/MfeCheckout/ducks/CartItem/Recipient/Recipient-Actions';
import { getCountryCodeFromTwoToThreeDigit } from '../../../../../../../state/ducks/Checkout/helpers/countryCode';
import MaskInput from '../TextFieldWrapper/MaskInput';

const styles = (theme) => ({
    inputWrapper: {
        marginBottom: '10px',
    },
    paddingLeft: {
        paddingLeft: '15px',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '0',
        },
    },
    paddingRight: {
        paddingRight: '15px',
        [theme.breakpoints.down('sm')]: {
            paddingRight: '0',
        },
    },
    padding8Left: {
        paddingLeft: '8px',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '0',
        },
    },
    padding8Right: {
        paddingRight: '8px',
        [theme.breakpoints.down('sm')]: {
            paddingRight: '0',
        },
    },
    spacingBtw: {
        margin: '10px 0px',
        width: '100%',
    },
    deliveryForm: {
        width: '100%',
    },
    btnSaveAddress: {
        boxShadow: 'none',
        textTransform: 'none',
        backgroundColor: theme.palette.buttonBackgroundColor,
        color: theme.palette.primary?.contrastText,
        borderRadius: '4px',
        display: 'block',
        fontWeight: 'bold',
        margin: '0 0 10px',
        padding: '10px 0',
        textAlign: 'center',
        width: '95%',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: theme.palette.buttonBackgroundColorSecondary,
            color: theme.palette.primary?.contrastText,
            boxShadow: 'none',
        },
    },
    btnCancelAddress: {
        textTransform: 'none',
        boxShadow: 'none',
        backgroundColor: theme.palette.white,
        color: theme.palette.buttonBackgroundColor,
        border: `1px solid ${theme.palette.buttonBackgroundColor}`,
        borderRadius: '4px',
        display: 'block',
        fontWeight: 'bold',
        margin: '0 0 10px',
        padding: '10px 0',
        textAlign: 'center',
        width: '95%',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: theme.palette.white,
            border: `1px solid ${theme.palette.buttonBackgroundColorSecondary}`,
            color: theme.palette.buttonBackgroundColorSecondary,
            boxShadow: 'none',
        },
    },
    apoInfoPaper: {
        margin: '10px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '10px',
        textDecoration: 'none',
        '& h6, & span': {
            textDecoration: 'none',
            fontSize: '1em',
        },
    },
    apoHelpLink: {
        color: '#00e',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    apoLink: {
        color: theme.palette.primary?.main,
        cursor: 'pointer',
        margin: '10px 0',
        outline: 'none',
    },
    greetingStandalone: {
        margin: '0 0 15px',
        padding: '0',
        fontStyle: 'italic',
        fontWeight: 'bold',
    },
    warning: {
        color: 'red',
    },
});

const AddressBookForm = ({
    bookAddressValues,
    callClearOrderItemErrors,
    callEnterpriseSaveAddressBook,
    callEnterpriseQASSaveRecipient,
    callSetOrderItemError,
    callResetQasAddressState,
    classes,
    featureFlags, formFieldState,
    getTextFieldProps,
    handleCancelAddressBookForm, handleCloseAddressBook,
    handleOnBlur, hasQasFailed,
    itemCountriesProdDeliverable,
    orderItem, orderItemErrors,
    pageType,
    relationshipList,
    savingType,
    updateFormFieldState,
    userSubmitProdFilterZipcode,
    userSubmitProdLocationType,
    validateFormFields,
}) => {
    const {
        orderItemIdQASModal, parentType, setParentType,
        setItemRecipientData, setOrderItemIdQASModal,
    } = useModalContext();

    const [addressSearch, setAddressSearch] = useState({
        focus: false,
        valueOnKeyUp: '',
    });
    const [formFieldValues, setFormFieldValues] = useState({
        firstName: '',
        lastName: '',
        relationship: '',
        locationType: 'Residence',
        address1: '',
        address2: '',
        organizationName: '',
        zipCode: '',
        city: '',
        state: '',
        country: 'US',
        phone: '',
        isAddressVerified: 'U',
        dpvIndicator: 'U',
    });
    const [isListFocus, setIsListFocus] = useState(false);
    const [openModalApoInfo, setOpenModalApoInfo] = useState(false);

    const error = orderItemErrors?.[orderItem.cartItemId]?.recipient?.validationErrors || {};
    const defaultError = orderItemErrors?.[orderItem.cartItemId]?.recipient?.errorMessage || '';

    // Add the error are not related with the inputs
    const errorKeys = error ? Object.keys(error) : [];

    // Error for the input fields
    const onlyInputErrors = getOnlyInputFieldErrors(errorKeys);

    // Errors is not related with the input fields
    const hasOtherErrors = getNonFieldErrors(errorKeys);

    const selCountry = formFieldValues.country || 'USA';
    const countryProperties = countriesProps[selCountry] || {};
    const isCountryUSAorCanada = isUsaOrCanada(selCountry);
    const productBrandId = orderItem.product.brandCode;
    const brandPresentationFamily = getBrandProductFamily(productBrandId);
    const lineItemType = orderItem.itemInfo?.lineItemType || '';
    const productPropertiesType = (lineItemType === 'GREETINGCARD-ITEM' || productBrandId === '1036') ? 'standalone' : (propertiesTypeByProduct[productBrandId] || 'flowers');

    const listProperties = getInputProperties(productPropertiesType);
    const fieldLabelProps = listProperties[formFieldValues.locationType]
        ? listProperties[formFieldValues.locationType].formFieldLabels
        : listProperties.Residence.formFieldLabels;

    const countryList = getListCountries(itemCountriesProdDeliverable);

    let AddressVerificationSearchComponent = AddressVerificationSearch;
    if (featureFlags['is-checkout-using-qas-v2']) {
        AddressVerificationSearchComponent = AddressVerificationSearchV2;
    }

    const formFieldRule = (event) => {
        const updateFieldState = { ...formFieldState };
        const updateFormFieldValues = { ...formFieldValues };

        let name = null;
        let value = null;

        if (event) {
            name = event.target.name;
            value = event.target.value;
        } else {
            name = 'locationType';
            value = updateFormFieldValues.locationType;
        }

        if (name === 'locationType') {
            if (['Residence', 'Apartment', 'POBox'].includes(value)) {
                updateFieldState.organizationName.required = false;
                updateFieldState.organizationName.flagError = false;
                updateFieldState.organizationName.errorMessage = '';
                updateFieldState.organizationName.alert = false;
                updateFieldState.address2.required = false;
                updateFieldState.address2.flagError = false;
                updateFieldState.address2.errorMessage = '';
                if (!updateFieldState.city.required) {
                    updateFieldState.city.required = true;
                    updateFieldState.city.errorMessage = '';
                } else if (updateFieldState.city.errorMessage === 'APO/FPO is required') {
                    updateFieldState.city.errorMessage = 'City is required';
                }
            } else if (value === 'APOFPO') {
                updateFieldState.address2.required = true;
                updateFieldState.city.required = true;
                updateFieldState.state.required = true;
                updateFieldState.organizationName.required = false;
                if (updateFieldState.city.errorMessage === 'City is required') {
                    updateFieldState.city.errorMessage = 'APO/FPO is required';
                }
            } else {
                updateFieldState.organizationName.required = true;
                updateFieldState.organizationName.flagError = false;
                updateFieldState.organizationName.errorMessage = '';

                // The error messages need be clean for the new kind of location type
                updateFieldState.firstName.flagError = false;
                updateFieldState.firstName.errorMessage = '';
                updateFieldState.lastName.flagError = false;
                updateFieldState.lastName.errorMessage = '';
            }
            updateFormFieldState(updateFieldState);
        } else if (name === 'country') {
            if (['US', 'USA', 'CA', 'CAN'].includes(value)) {
                updateFieldState.state.required = true;
                updateFieldState.zipCode.required = true;
            } else {
                updateFieldState.state.required = false;
                updateFieldState.state.flagError = false;
                updateFieldState.state.errorMessage = '';
                updateFieldState.zipCode.required = false;
                updateFieldState.zipCode.flagError = false;
                updateFieldState.zipCode.errorMessage = '';
            }

            // clearing zipcode and city values after changing country
            if (['US', 'USA', 'CA', 'CAN'].includes(value)) {
                updateFormFieldValues.state = '';
            }

            updateFormFieldValues.zipCode = '';
            updateFormFieldValues.city = '';
            updateFormFieldValues.country = value;

            setFormFieldValues((prevState) => ({
                ...prevState,
                ...updateFormFieldValues,
            }));
            updateFormFieldState(updateFieldState);
        } else if (name === 'phone') {
            if (
                (
                    lineItemType === 'GREETINGCARD-ITEM'
                    || productBrandId === '1036'
                )
                && orderItem.addons?.length > 0 && !updateFieldState.phone.required
            ) {
                updateFieldState.phone.required = true;
                updateFieldState.phone.flagError = false;
                updateFieldState.phone.errorMessage = '';
            } else if (brandPresentationFamily === 'food') {
                if (!value && updateFieldState.phone.required) {
                    updateFieldState.phone.required = false;
                    updateFieldState.phone.flagError = false;
                    updateFieldState.phone.errorMessage = '';
                } else if (!updateFieldState.phone.required) {
                    updateFieldState.phone.required = true;
                    updateFieldState.phone.flagError = false;
                    updateFieldState.phone.errorMessage = '';
                }
            } else if (brandPresentationFamily !== 'food' && !formFieldState.phone.required) {
                updateFieldState.phone.required = true;
                updateFieldState.phone.flagError = false;
                updateFieldState.phone.errorMessage = '';
            }
        }

        if (name === 'zipCode') {
            if (value.length === 0) {
                updateFormFieldValues.state = '';
                updateFormFieldValues.zipCode = '';
                updateFormFieldValues.city = '';
                setFormFieldValues(updateFormFieldValues);
            }
        }

        if (name === 'address1') {
            setAddressSearch({ focus: true, valueOnKeyUp: value });
        }

        if (
            ((name === 'address1' || name === 'address2' || name === 'email') && error.error !== '')
            || (name === 'email' && error.email) // NBCU product clean the email if the user is adding it
        ) {
            if (defaultError) {
                callClearOrderItemErrors(
                    orderItem.cartItemId,
                    'recipient',
                    {
                        errType: 'clearAllFields',
                        field: '',
                    },
                );
            }
        }
    };

    useEffect(() => {
        if (formFieldValues.locationType) {
            formFieldRule({
                target: { name: 'locationType', value: formFieldValues.locationType },
            });
        }
    }, [formFieldValues.locationType]);

    useEffect(() => {
        const updateFieldState = { ...formFieldState };
        callResetQasAddressState();

        if (parentType !== 'addressbook') {
            setParentType('addressbook');
        }

        if ((lineItemType === 'GREETINGCARD-ITEM' || productBrandId === '1036') && orderItem.addons?.length > 0) {
            updateFieldState.phone.required = true;
            updateFieldState.phone.flagError = false;
            updateFieldState.phone.errorMessage = '';
        } else if (brandPresentationFamily === 'food' && formFieldState.phone.required) {
            updateFieldState.phone.required = false;
            updateFieldState.phone.flagError = false;
            updateFieldState.phone.errorMessage = '';
        } else if (brandPresentationFamily !== 'food' && !formFieldState.phone.required) {
            updateFieldState.phone.required = true;
            updateFieldState.phone.flagError = false;
            updateFieldState.phone.errorMessage = '';
        }

        if (bookAddressValues && bookAddressValues.firstName) {
            const updateFormFieldValues = recipientBuilder(bookAddressValues);
            const fieldsToValidate = ['address1', 'address2', 'city', 'state', 'country', 'zipCode'];

            if (brandPresentationFamily !== 'food') {
                fieldsToValidate.push('phone');
            }

            if (!['Residence', 'Apartment', 'APOFPO', 'POBox'].includes(updateFormFieldValues.locationType)) {
                fieldsToValidate.push('organizationName');
                formFieldRule({
                    target: { name: 'locationType', value: updateFormFieldValues.locationType },
                });
            }

            if (updateFormFieldValues?.phone) {
                const maskInputFun = MaskInput.Phone;
                const resMaskInput = maskInputFun(updateFormFieldValues.phone);
                if (resMaskInput) {
                    updateFormFieldValues.phone = resMaskInput.maskInputVal;
                }
            }

            validateFormFields(fieldsToValidate, updateFormFieldValues, false);
            setFormFieldValues((prevState) => ({
                ...prevState,
                ...updateFormFieldValues,
            }));
        }

        if (savingType !== 'edit') {
            // Country can be deliverable is not present in the current country
            // we select the first country on the deliverable list
            const updateFormFieldValues = { ...formFieldValues };
            let country = updateFormFieldValues.country || 'USA';

            if (country.length !== 3) {
                country = getCountryCodeFromTwoToThreeDigit(country) || country;
            }

            if (itemCountriesProdDeliverable && !itemCountriesProdDeliverable.includes(country)) {
                country = itemCountriesProdDeliverable[0];
            }

            if (
                userSubmitProdFilterZipcode
                && userSubmitProdFilterZipcode !== '00000'
                && userSubmitProdFilterZipcode.length >= 5
            ) {
                updateFormFieldValues.zipCode = userSubmitProdFilterZipcode;
                updateFormFieldValues.locationType = userSubmitProdLocationType;
                triggerStateCityData(
                    userSubmitProdFilterZipcode, null,
                    formFieldValues, setFormFieldValues, validateFormFields,
                    orderItemErrors, orderItem, callSetOrderItemError,
                    featureFlags, itemCountriesProdDeliverable,
                );
            }
            setFormFieldValues((prevState) => ({
                ...prevState,
                ...updateFormFieldValues,
                country,
            }));
        }
    }, []);

    const handleContinueToProcess = () => {
        if (!error.zipCode) {
            const formattedRecipientData = getFormattedRecipientData(formFieldValues, false);
            const fieldsToValidate = getFieldsToValidateRecipient(formattedRecipientData, formFieldState, false);

            if (formFieldValues.phone) {
                formFieldValues.phoneNumber = formFieldValues.phone;
            }

            let reqObj = {
                recipient: formFieldValues,
                orderItemId: orderItem.cartItemId,
                typeQAS: '',
                addressQASSelected: {},
                parentType,
                handleCallBack: handleCancelAddressBookForm,
            };

            if (fieldsToValidate?.length > 0) {
                validateFormFields(fieldsToValidate, formFieldValues, false);
            } else if (featureFlags['is-qas-address-verification-enabled'] && !hasQasFailed) {
                reqObj = {
                    recipient: formattedRecipientData,
                    orderItemId: orderItem.cartItemId,
                    dpvIndicator: 'N',
                    isAddressVerified: 'O',
                    handleCallBack: handleCloseAddressBook,
                    parentType,
                };

                if (orderItemIdQASModal !== orderItem.cartItemId) {
                    setOrderItemIdQASModal(orderItem.cartItemId);
                }

                // populate the data through context to recipientForm
                setItemRecipientData(formattedRecipientData);

                // call start qas process
                callEnterpriseQASSaveRecipient(reqObj);
            } else {
                if (orderItemIdQASModal !== orderItem.cartItemId) {
                    setOrderItemIdQASModal(orderItem.cartItemId);
                }

                reqObj.handleCallBack = handleCloseAddressBook;

                callEnterpriseSaveAddressBook(reqObj);

                // populate the data through context to recipientForm
                setItemRecipientData(formattedRecipientData);
            }
        }
    };

    const handleFieldFocus = (event) => {
        if (event.target.name === 'address1') {
            setAddressSearch({ focus: true, valueOnKeyUp: event.target.value });
        }
    };

    const handleAddressSearchBlur = () => {
        setAddressSearch({ focus: false, valueOnKeyUp: '' });
    };

    const handleOnKeyUp = (event) => {
        if (event.target.name === 'address1') {
            setAddressSearch({ focus: addressSearch.focus, valueOnKeyUp: event.target.value });

            // If the Search QAS is active and User use arrow down in the input address 1 in the keyboard
            // focus the list in the menu.
            if (featureFlags['is-qas-address-suggestions-enabled'] && event.keyCode === 40 && !isListFocus) {
                setIsListFocus(true);
            }
        }
    };

    const handleFieldBlur = (fieldName, response) => {
        const updateResponse = response;
        handleOnBlur(fieldName, updateResponse, formFieldValues);
    };

    const handleFieldChange = (event, response) => {
        const updateFormFieldValues = { ...formFieldValues };
        const fieldValue = event.target.value;
        const fieldName = event.target.name;
        const fieldChangeObj = event;

        updateFormFieldValues[fieldName] = fieldValue;

        // Don't allow first characte is space
        if (fieldChangeObj.target.value && fieldChangeObj.target.value === ' ') {
            fieldChangeObj.target.value = '';
        }

        if (error && error[fieldName]) {
            callClearOrderItemErrors(
                orderItem.cartItemId,
                'recipient',
                {
                    errType: '',
                    field: fieldName,
                },
            );
        }

        formFieldRule(fieldChangeObj);
        if (fieldName === 'city') {
            updateFormFieldValues.city = fieldChangeObj.target.value.toLowerCase().replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
        } else if (fieldName === 'address1' && fieldChangeObj.target.value) {
            // Important: This process is for dont allow the user add more 12 digits
            // in the address like the credit card in it.

            const addressValue = fieldChangeObj.target.value;

            // Get only  the number from the address
            const digitValues = addressValue.match(/\d/g);

            if (digitValues && digitValues.length > 12) {
                // Get the last digit position in the string
                let positionLastNumber = -1;
                Array.from(addressValue).forEach((value, index) => {
                    // the character is a digit, set the position
                    if (/^\d+$/.test(value)) {
                        positionLastNumber = index;
                    }
                });

                if (fieldChangeObj.target.value && positionLastNumber > 0
                    && fieldChangeObj.target.value.length > positionLastNumber
                ) {
                    // Get remove the last digit from the string and update the field address
                    const fieldUpdateValue = Array.from(addressValue);
                    delete fieldUpdateValue[positionLastNumber];
                    fieldChangeObj.target.value = fieldUpdateValue.join('');
                }
            }
        } else if (fieldName === 'country' && fieldValue) {
            // clearing zipcode and city values after changing country
            if (['US', 'USA', 'CA', 'CAN'].includes(fieldValue)) {
                updateFormFieldValues.state = '';
                updateFormFieldValues.city = '';
                updateFormFieldValues.zipCode = '';
            } else {
                updateFormFieldValues.city = '';
                updateFormFieldValues.state = 'OS';
                updateFormFieldValues.zipCode = '00000';
            }

            updateFormFieldValues.country = fieldValue;
        } else if (fieldName === 'locationType' && ['Residence', 'Apartment', 'APOFPO', 'POBox'].includes(fieldValue)) {
            updateFormFieldValues.organizationName = '';
        } else if (fieldName === 'zipCode') {
            if (fieldValue.length >= 5 && fieldValue !== '00000') {
                triggerStateCityData(
                    fieldValue, formFieldValues.city,
                    formFieldValues, setFormFieldValues, validateFormFields,
                    orderItemErrors, orderItem, callSetOrderItemError,
                    featureFlags, itemCountriesProdDeliverable,
                );
            } else if (fieldValue === '00000' && updateFormFieldValues.country && !isUsaOrCanada(updateFormFieldValues.country)) {
                updateFormFieldValues.city = 'Overseas';
                updateFormFieldValues.state = 'OS';
            } else if (fieldValue.length === 0) {
                updateFormFieldValues.city = '';
                updateFormFieldValues.state = '';
            } else if (fieldValue.indexOf('00000') >= 0 && updateFormFieldValues.country && isUsaOrCanada(updateFormFieldValues.country)) {
                updateFormFieldValues.city = '';
                updateFormFieldValues.state = '';
            }

            if (fieldValue?.length >= 5) {
                const regCAN = /(^[A-Z|a-z]\d[A-Z|a-z] \d[A-Z|a-z]\d$)/;
                const zipCode = fieldValue || '';
                const isValidCANZipCode = regCAN.test(zipCode);

                const regUS = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                const isValidUSZipCode = regUS.test(zipCode);
                if (zipCode) {
                    if (isValidCANZipCode && itemCountriesProdDeliverable.includes('CAN')) {
                        updateFormFieldValues.country = 'CAN';
                    } else if (isValidUSZipCode && !['US', 'USA'].includes(formFieldValues.country) && itemCountriesProdDeliverable.includes('USA')) {
                        updateFormFieldValues.country = 'USA';
                    } else if (['US', 'USA', 'CA', 'CAN'].includes(formFieldValues.country) && !isValidCANZipCode && !isValidUSZipCode) {
                        updateFormFieldValues.city = '';
                        updateFormFieldValues.state = '';
                    }
                }
                validateFormFields(['zipCode'], updateFormFieldValues, false);
            }
        }

        setFormFieldValues(updateFormFieldValues);
        if (response) {
            handleFieldBlur(fieldName, response, updateFormFieldValues);
        }
    };

    const fillRecipientAddress = async (data) => {
        const recipientAddress = {
            ...formFieldValues,
            address1: data.addressLine1,
            address2: data.addressLine2?.substring(0, 30),
            city: data.city,
            state: data.state,
            country: data.country,
            zipCode: data.zipcode,
        };

        setFormFieldValues(recipientAddress);

        const fieldsToValidate = ['address1', 'address2', 'city', 'state', 'country', 'zipCode'];
        validateFormFields(fieldsToValidate, recipientAddress, false);

        // User select one address from the list QAS the list need change the focus to false.
        setIsListFocus(false);
    };

    const handleOpenCloseModalApoInfo = () => {
        setOpenModalApoInfo(!openModalApoInfo);
    };

    return (
        <Grid container>
            <form id="addressBookForm" name="deliveryForm" className={classes.deliveryForm}>
                <Grid container>
                    <Grid xs={12} md={6} lg={6} item className={`${classes.inputWrapper} ${classes.padding8Right}`}>
                        <TextFieldWrapper
                            customInput
                            label={fieldLabelProps.firstName}
                            name="firstName"
                            inputType="Alphabets"
                            maskInput="fullName"
                            flagError={getFlagError(formFieldState.firstName, error.firstName)}
                            errorMessage={error.firstName || formFieldState.firstName.errorMessage}
                            required={formFieldState.firstName.required}
                            variant="outlined"
                            val={formFieldValues.firstName}
                            max={brandPresentationFamily === 'food' ? 14 : 25}
                            isInputFilled={handleFieldBlur}
                            setTextInputState={handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping given-name"
                        />
                    </Grid>
                    <Grid xs={12} md={6} lg={6} item className={`${classes.inputWrapper} ${classes.padding8Left}`}>
                        <TextFieldWrapper
                            customInput
                            label={fieldLabelProps.lastName}
                            name="lastName"
                            inputType="Alphabets"
                            flagError={getFlagError(formFieldState.lastName, error.lastName)}
                            errorMessage={error.lastName || formFieldState.lastName.errorMessage}
                            required={formFieldState.lastName.required}
                            variant="outlined"
                            val={formFieldValues.lastName}
                            max={brandPresentationFamily === 'food' ? 14 : 25}
                            isInputFilled={handleFieldBlur}
                            setTextInputState={handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping family-name"
                        />
                    </Grid>
                    <Grid xs={12} item className={classes.inputWrapper}>
                        <TextFieldWrapper
                            customSelect
                            label="Relationship"
                            name="relationship"
                            flagError={getFlagError(formFieldState.relationship, error.relationship)}
                            errorMessage={error.relationship || formFieldState.relationship.errorMessage}
                            required={formFieldState.relationship.required}
                            dropdown={getListRelationShipDropdown(relationshipList)}
                            val={formFieldValues.relationship}
                            isInputFilled={handleFieldBlur}
                            setTextInputState={handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                        />
                    </Grid>
                    <Grid xs={12} item className={classes.inputWrapper}>
                        <TextFieldWrapper
                            customSelect
                            label={fieldLabelProps.locationType}
                            name="locationType"
                            inputType="Alphabets"
                            flagError={getFlagError(formFieldState.locationType, error.locationType)}
                            errorMessage={error.locationType || formFieldState.locationType.errorMessage}
                            required={formFieldState.locationType.required}
                            variant="outlined"
                            dropdown={getListLocationTypes(productPropertiesType)}
                            val={formFieldValues.locationType}
                            max={200}
                            isInputFilled={handleFieldBlur}
                            setTextInputState={handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping location-type"
                        />
                    </Grid>
                    {
                        (!!fieldLabelProps.organizationName)
                        && (
                            <Grid xs={12} item className={classes.inputWrapper}>
                                <TextFieldWrapper
                                    customInput
                                    label={fieldLabelProps.organizationName}
                                    name="organizationName"
                                    inputType="AlphaNumericSpecial"
                                    flagError={formFieldState.organizationName.flagError}
                                    errorMessage={formFieldState.organizationName.errorMessage}
                                    required={formFieldState.organizationName.required}
                                    variant="outlined"
                                    val={formFieldValues.organizationName}
                                    max={200}
                                    isInputFilled={handleFieldBlur}
                                    setTextInputState={handleFieldChange}
                                    returnFieldProps={getTextFieldProps}
                                    autoComplete="section-shipping organization"
                                />
                            </Grid>
                        )
                    }
                    <Grid item xs={12} className={classes.inputWrapper}>
                        {/* Address Search - Google Start */}
                        {(useGoogleAddressSearch(featureFlags, hasQasFailed, formFieldValues))
                            && (
                                <GoogleAddressSearch
                                    getPreFillAddressDetails={fillRecipientAddress}
                                    searchId={`addressbook-address-line1-${orderItem.cartItemId}`}
                                >
                                    <TextFieldWrapper
                                        customInput
                                        label={fieldLabelProps.address1}
                                        id={`addressbook-address-line1-${orderItem.cartItemId}`}
                                        key={`recipientAddressSearchTF-${orderItem.cartItemId}`}
                                        name="address1"
                                        inputType="AlphaNumericSpecial"
                                        fullWidth
                                        flagError={getFlagError(formFieldState.address1, error.address1)}
                                        errorMessage={error.address1 || formFieldState.address1.errorMessage}
                                        required={formFieldState.address1.required}
                                        val={formFieldValues.address1}
                                        max={100}
                                        isInputFilled={handleFieldBlur}
                                        setTextInputState={handleFieldChange}
                                        returnFieldProps={getTextFieldProps}
                                        autoComplete="section-shipping shipping street-address"
                                        infoHelpText="DELIVERY NOTES: GIFTS CANNOT BE DELIVERED TO P.O. BOXES OR APO INSTALLATIONS."
                                    />
                                </GoogleAddressSearch>
                            )}
                        {/* Address Search - Google End */}
                        {/* Address Verification Search - QAS Start */}
                        {(useQasAddressSearch(featureFlags, hasQasFailed) && isCountryUSAorCanada)
                            && (
                                <AddressVerificationSearchComponent
                                    city={formFieldValues.city}
                                    countryCode={formFieldValues.country}
                                    getPreFillAddressDetails={fillRecipientAddress}
                                    isFocus={isListFocus}
                                    isValidZipCode={!(error.zipCode || formFieldState.zipCode.errorMessage)}
                                    onBlurHandler={handleAddressSearchBlur}
                                    pageType={pageType}
                                    searchId={`addressbook-address-line1-${orderItem.cartItemId}`}
                                    searchText={addressSearch.valueOnKeyUp}
                                    searchTextFocus={addressSearch.focus}
                                    state={formFieldValues.state}
                                    useGeoLocation={featureFlags['is-qas-geo-location-enabled']}
                                    zipCode={formFieldValues.zipCode}
                                >
                                    <TextFieldWrapper
                                        customInput
                                        label={fieldLabelProps.address1}
                                        id={`addressbook-address-line1-${orderItem.cartItemId}`}
                                        key={`recipientAddressSearchTF-${orderItem.cartItemId}`}
                                        name="address1"
                                        inputType="AlphaNumericSpecial"
                                        fullWidth
                                        required={formFieldState.address1.required}
                                        flagError={getFlagError(formFieldState.address1, error.address1)}
                                        errorMessage={error.address1 || formFieldState.address1.errorMessage}
                                        val={formFieldValues.address1}
                                        max={100}
                                        handleOnFocus={handleFieldFocus}
                                        handleOnKeyUp={handleOnKeyUp}
                                        isInputFilled={handleFieldBlur}
                                        setTextInputState={handleFieldChange}
                                        returnFieldProps={getTextFieldProps}
                                        autoComplete="section-shipping address-line1"
                                        infoHelpText="DELIVERY NOTES: GIFTS CANNOT BE DELIVERED TO P.O. BOXES OR APO INSTALLATIONS."
                                    />
                                </AddressVerificationSearchComponent>
                            )}
                        {/* Address Verification Search - QAS End */}
                        {
                            (
                                (!featureFlags['is-google-places-enabled'] && !featureFlags['is-qas-address-suggestions-enabled'] && isCountryUSAorCanada)
                                || (!featureFlags['is-google-places-enabled'] && !isCountryUSAorCanada)
                            ) && (
                                <TextFieldWrapper
                                    customInput
                                    label={fieldLabelProps.address1}
                                    id={`addressbook-address-line1-${orderItem.cartItemId}`}
                                    key={`recipientAddressSearchTF-${orderItem.cartItemId}`}
                                    name="address1"
                                    inputType="AlphaNumericSpecial"
                                    fullWidth
                                    required={formFieldState.address1.required}
                                    flagError={getFlagError(formFieldState.address1, error.address1)}
                                    errorMessage={error.address1 || formFieldState.address1.errorMessage}
                                    val={formFieldValues.address1}
                                    max={100}
                                    isInputFilled={handleFieldBlur}
                                    setTextInputState={handleFieldChange}
                                    returnFieldProps={getTextFieldProps}
                                    autoComplete="section-shipping address-line1"
                                    infoHelpText="DELIVERY NOTES: GIFTS CANNOT BE DELIVERED TO P.O. BOXES OR APO INSTALLATIONS."
                                />
                            )
                        }
                        {(error.address1 && !formFieldState.address1.flagError)
                            && <InlineErrorMessage error={error.address1} />}
                    </Grid>
                    <Grid xs={12} item className={classes.inputWrapper}>
                        <DisplayLinkField
                            linkText="Add Apartment #, Suite, Floor etc. (optional)"
                            required={formFieldState.address2.required}
                            flagError={formFieldState.address2.flagError}
                            val={formFieldValues.address2}
                            id={`address-line2-${orderItem.cartItemId}`}
                            plusIcon={false}
                        >
                            <TextFieldWrapper
                                customInput
                                label={fieldLabelProps.address2}
                                id={`address-line2-${orderItem.cartItemId}`}
                                name="address2"
                                inputType="AlphaNumericSpecial"
                                flagError={formFieldState.address2.flagError}
                                errorMessage={formFieldState.address2.errorMessage}
                                required={formFieldState.address2.required}
                                variant="outlined"
                                val={formFieldValues.address2}
                                max={30}
                                isInputFilled={handleFieldBlur}
                                setTextInputState={handleFieldChange}
                                returnFieldProps={getTextFieldProps}
                                autoComplete="section-shipping address-line2"
                            />
                        </DisplayLinkField>
                    </Grid>
                    {
                        isCountryUSAorCanada && (
                            <Grid item xs={12} md={4} lg={4} className={`${classes.inputWrapper} ${classes.paddingRight}`}>
                                <TextFieldWrapper
                                    customInput
                                    label={countryProperties?.zipCode?.label}
                                    name="zipCode"
                                    inputType={countryProperties.zipCode.inputType}
                                    inputFieldType={countryProperties.zipCode.inputFieldType}
                                    validateRule="ZipCode"
                                    required={formFieldState.zipCode.required}
                                    flagError={getFlagError(formFieldState.zipCode, error.zipCode)}
                                    errorMessage={error.zipCode || formFieldState.zipCode.errorMessage}
                                    val={formFieldValues.zipCode}
                                    max={countryProperties.zipCode.max}
                                    min={countryProperties.zipCode.min}
                                    isInputFilled={handleFieldBlur}
                                    setTextInputState={handleFieldChange}
                                    returnFieldProps={getTextFieldProps}
                                    autoComplete="section-shipping postal-code"
                                    country={formFieldValues.country}
                                />
                            </Grid>
                        )
                    }
                    <Grid xs={12} md={isCountryUSAorCanada ? 4 : 12} lg={isCountryUSAorCanada ? 4 : 12} item className={classes.inputWrapper}>
                        <TextFieldWrapper
                            customInput
                            label={formFieldValues.locationType === 'APOFPO' ? 'APO/FPO' : fieldLabelProps.city}
                            name="city"
                            inputType="Alphabets"
                            flagError={formFieldState.city.flagError}
                            errorMessage={formFieldState.city.errorMessage}
                            required={formFieldState.city.required}
                            variant="outlined"
                            val={formFieldValues.city || ''}
                            max={25}
                            isInputFilled={handleFieldBlur}
                            setTextInputState={handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping address-level2"
                        />
                    </Grid>
                    {
                        isCountryUSAorCanada && (
                            <Grid xs={12} md={4} lg={4} item className={`${classes.inputWrapper} ${classes.paddingLeft}`}>
                                <TextFieldWrapper
                                    label="State"
                                    customSelect
                                    name="state"
                                    required={formFieldState.state.required}
                                    flagError={getFlagError(formFieldState.state, error.state)}
                                    errorMessage={error.state || formFieldState.state.errorMessage}
                                    val={formFieldValues.state}
                                    dropdown={getListStates(formFieldValues.country || 'US', formFieldValues.locationType)}
                                    max={200}
                                    isInputFilled={handleFieldBlur}
                                    setTextInputState={handleFieldChange}
                                    returnFieldProps={getTextFieldProps}
                                    autoComplete="section-shipping address-level1"
                                />
                            </Grid>
                        )
                    }
                    {
                        formFieldValues.locationType === 'APOFPO'
                        && (
                            <Grid item xs={12} className={classes.apoLink}>
                                <span
                                    className={classes.apoHelpLink}
                                    id="recipientFormAPIHelpLink"
                                    onClick={handleOpenCloseModalApoInfo}
                                    onKeyDown={handleOpenCloseModalApoInfo}
                                    role="link"
                                    tabIndex={0}
                                >
                                    Help with an APO/FPO
                                </span>
                                {
                                    openModalApoInfo && (
                                        <div className={classes.apoInfoPaper}>
                                            <Typography component="span" variant="h6" id="apofpo-modal-title">
                                                APO/FPO Address Help.
                                            </Typography>
                                            <Typography component="span" variant="subtitle1" id="apofpo-modal-description">
                                                When ordering, choose APO/FPO MILITARY and select from the Armed Forces delivery locations within the State drop down menu field. Please allow at least 5 weeks transit time for delivery.
                                            </Typography>
                                        </div>
                                    )
                                }
                            </Grid>
                        )
                    }

                    <Grid item xs={12} className={`${classes.inputWrapper}`}>
                        <TextFieldWrapper
                            customSelect
                            label="Country"
                            name="country"
                            flagError={getFlagError(formFieldState.country, error.country)}
                            errorMessage={error.country || formFieldState.country.errorMessage}
                            required={formFieldState.country.required}
                            val={formFieldValues.country}
                            dropdown={countryList}
                            returnFieldProps={getTextFieldProps}
                            isInputFilled={handleFieldBlur}
                            setTextInputState={handleFieldChange}
                            autoComplete="section-shipping country"
                        />
                    </Grid>
                    <Grid xs={12} item className={classes.inputWrapper}>
                        <TextFieldWrapper
                            customInput
                            label={fieldLabelProps.phone}
                            name="phone"
                            flagError={getFlagError(formFieldState.phone, error.phoneNumber)}
                            errorMessage={error.phoneNumber || formFieldState.phone.errorMessage}
                            required={formFieldState.phone.required}
                            variant="outlined"
                            inputFieldType="tel" // set input type="tel" for numberic keyboard to appear mobile (tel type is needed for iphone)
                            inputType="Phone"
                            maskInput="Phone"
                            validateRule="Phone"
                            val={formFieldValues.phone}
                            min={10}
                            max={15}
                            isInputFilled={handleFieldBlur}
                            setTextInputState={handleFieldChange}
                            returnFieldProps={getTextFieldProps}
                            autoComplete="section-shipping tel"
                        />
                        {
                            (
                                lineItemType === 'GREETINGCARD-ITEM'
                                || productBrandId === '1036'
                            )
                            && orderItem.addons?.length > 0
                            && (
                                <p className={classes.greetingStandalone}><sup className={classes.warning}>*</sup>Recipient phone number will be used to unlock this gift card.</p>
                            )
                        }
                    </Grid>
                    <Grid xs={12} className={classes.spacingBtw} item>
                        {
                            (
                                (
                                    hasOtherErrors?.length > 0
                                    || (errorKeys?.length > 0 && onlyInputErrors.length > 0)
                                )
                                && defaultError
                            )
                                ? (
                                    <ErrorMessage
                                        noShadow
                                        error={defaultError}
                                    />
                                ) : null
                        }
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} md={6} lg={6}>
                            <Grid container justifyContent="flex-start">
                                <Button
                                    id={`btn-cancel-payment-${orderItem.cartItemId}`}
                                    data-test="recipient-btn-cancel"
                                    name="recipientCancelButton"
                                    variant="contained"
                                    className={classes.btnCancelAddress}
                                    onClick={() => handleCancelAddressBookForm()}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} md={6} lg={6}>
                            <Grid container justifyContent="flex-end">
                                <Button
                                    id={`btn-continue-payment-${orderItem.cartItemId}`}
                                    data-test="recipient-btn-continue"
                                    name="recipientContinueButton"
                                    variant="contained"
                                    className={classes.btnSaveAddress}
                                    onClick={() => handleContinueToProcess('save')}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </form>
        </Grid>
    );
};

AddressBookForm.propTypes = {
    bookAddressValues: object.isRequired,
    callEnterpriseSaveAddressBook: func.isRequired,
    callClearOrderItemErrors: func.isRequired,
    callEnterpriseQASSaveRecipient: func.isRequired,
    callSetOrderItemError: func.isRequired,
    callResetQasAddressState: func.isRequired,
    classes: object.isRequired,
    featureFlags: object.isRequired,
    formFieldState: object.isRequired,
    getTextFieldProps: func.isRequired,
    handleCancelAddressBookForm: func.isRequired,
    handleCloseAddressBook: func.isRequired,
    handleOnBlur: func.isRequired,
    hasQasFailed: bool.isRequired,
    itemCountriesProdDeliverable: arrayOf(string).isRequired,
    orderItem: shape({
        lineItemType: string,
    }).isRequired,
    orderItemErrors: object.isRequired,
    pageType: string.isRequired,
    relationshipList: object,
    savingType: string,
    updateFormFieldState: func.isRequired,
    userSubmitProdFilterZipcode: string.isRequired,
    userSubmitProdLocationType: string.isRequired,
    validateFormFields: func.isRequired,
};

AddressBookForm.defaultProps = {
    relationshipList: {},
    savingType: '',
};

const mapStateToProps = (state) => ({
    error: getRecipientFormError(state),
    featureFlags: getFlags(state),
    hasQasFailed: getHasQasFailed(state),
    orderItemErrors: getOrderItemErrors(state),
    userSubmitProdLocationType: getLocationType(state),
    userSubmitProdFilterZipcode: getUserSubmittedProductFilterZipcode(state),
    userType: getUserType(state),
});

const mapDispatchToProps = (dispatch) => ({
    callClearOrderItemErrors: bindActionCreators(clearOrderItemErrors, dispatch),
    callEnterpriseSaveAddressBook: bindActionCreators(enterpriseSaveAddressBook, dispatch),
    callEnterpriseQASSaveRecipient: bindActionCreators(enterpriseQASSaveRecipient, dispatch),
    callSetOrderItemError: bindActionCreators(setOrderItemError, dispatch),
    callResetQasAddressState: bindActionCreators(resetQasAddressState, dispatch),
});

const AddressBookFormValidation = withValidation(AddressBookForm, inputStates);

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withStyles(styles),
)(AddressBookFormValidation);
